import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {

  logedin = false;
  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.checkLoggedin();
  }

  public checkLoggedin(){
    this.logedin = this.authService.isLoggedIn();
  }
  openDialog() {
    const customerLoginButton = document.getElementById('customerlogin');
    if (customerLoginButton) {
        customerLoginButton.click();
    } 
  }

}
